import { TrackingEvent } from '../tracking/types';

export enum FlutterInappwebviewHandler {
  TRACK_EVENT = 'trackEvent',
  CLOSE_CASHIER = 'closeCashier',
  TRANSACTION_INIT = 'transactionInit',

  GET_INBOX_MESSAGES = 'getInboxMessages',
  GET_INBOX_BADGE = 'getInboxBadge',
  MARK_MESSAGE_OPENED = 'markMessageOpened',
}

export interface TransactionInitEvent {
  value: string;
  currency: string;
  playerId: string;
  playerEmail: string;
  playerPhone: string;
}

export interface GetInboxMessagesEvent {
  offset?: number;
  limit?: number;
  filterOpened?: number;
}
export interface MarkMessageOpenedEvent {
  id: number;
}

export type PublishEventData = TrackingEvent | TransactionInitEvent | GetInboxMessagesEvent | MarkMessageOpenedEvent;

export interface FlutterInappwebview {
  callHandler(handler: FlutterInappwebviewHandler, data: TrackingEvent): void;
}
